import { PrinterPosPauseOutlineIcon } from './PrinterPosPauseOutlineIcon';

/**
 * author: Colton Wiscombe
 * id FCF57215-34E5-44F7-9DF9-BDFF862CAAF6
 * name printer-pos-pause-outline
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/printer-pos-pause-outline.svg
 * tags
 * - Printer 
 */
export const PrinterPointOfSalePauseOutlineIcon = PrinterPosPauseOutlineIcon;
export default PrinterPointOfSalePauseOutlineIcon